<template>
  <div class="pt-4 pb-20 px-4">
    <h3 class="text-2xl font-bold mb-5">
      Create Account
    </h3>
    <template v-if="loading">
      <div class="rounded-xl" :class="[$theme.cardBg]">
        <LoadingBlock />
      </div>
    </template>
    <template v-else>
      <div>
        <div class="mt-4">
          <label for="title" class="block text-sm font-medium leading-6" :class="[$theme.cardLabelTextColor]">
            Title
          </label>
          <div class="mt-2">
            <input
                v-model="form.title"
                type="text"
                id="title"
                class="block w-full rounded-lg border py-2 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:border-transparent"
                :class="[
                    $theme.cardLabelTextColor,
                    $theme.inputPlaceTextColor,
                    $theme.inputRingFocusColor,
                    $theme.inputBorderColor,
                    $theme.inputRingColor,
                    $theme.cardBg,
                ]"
            />
          </div>
        </div>
        <div class="mt-4">
          <label for="side_mode" class="block text-sm font-medium leading-6" :class="[$theme.cardLabelTextColor]">App Type</label>
          <div class="mt-2">
            <select
                v-model="form.app_type" id="side_mode"
                class="block w-full rounded-lg border py-2 shadow-sm ring-1 ring-inset focus:ring-2 focus:ring-inset focus:border-transparent"
                :class="[
                    $theme.baseTextColor,
                    $theme.inputPlaceTextColor,
                    $theme.inputRingFocusColor,
                    $theme.borderOrange,
                    $theme.inputRingColor,
                    $theme.cardBg,
                ]"
            >
              <option v-for="app_type in app_types" :key="app_type.key" :value="app_type.key">
                {{ app_type.title }}
              </option>
            </select>
          </div>
        </div>
        <div class="mt-6">
          <button
              @click="onCreateAccount"
              type="button"
              class="flex w-full items-center justify-center rounded-xl px-3 py-3 font-semibold text-white shadow-sm"
              :class="[formProcessing ? 'opacity-50 pointer-events-none' : '',
                $theme.bgBtn,
                $theme.whiteText,
              ]"
          >
            <template v-if="formProcessing">
              <ButtonSpinner />
            </template>
            Create Account
          </button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import LoadingBlock from "@/components/LoadingBlock.vue";
import ButtonSpinner from "@/components/ButtonSpinner.vue";

export default {
  components: {
    ButtonSpinner,
    LoadingBlock,
  },

  methods: {
    onCreateAccount() {
      this.formProcessing = true;

      this.$api.post('/forex/accounts', this.form).then((result) => {
        console.log(result);
        this.$router.push({
          name: 'forex-account',
          params: {
            id: result.data.id
          }
        })
      }).catch(e => {
        console.log(e.response)
        //this.formError = e.response.data;
        this.formProcessing = false;
      })
    },
  },

  data() {
    return {
      loading: false,
      formProcessing: false,
      formError: null,
      form: {
        title: '',
        app_type: 'mt5',
      },
      app_types: [
        {
          title: 'MetaTrader 4',
          key: 'mt4',
        },
        {
          title: 'MetaTrader 5',
          key: 'mt5',
        }
      ],
    }
  }
}
</script>
